import React, { useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import Options from "../options";
import { Link } from "src/types/link";
import Collapse from "../../../animation/collapse";
import CopyLink from "../copyLink";

import cx from "classnames";
import styles from "./linksettings.module.scss";
import _ from "lodash";
import Text from "src/components/text";
interface LinkSettingsProps {
  link: Link;
  onClose: () => void;
  textContent: any;
}

const LinkSettings: React.FC<LinkSettingsProps> = ({
  link,
  onClose,
  textContent,
}) => {
  const [isLinkUpdated, setIsLinkUpdated] = React.useState(false);
  const [openLinkPanel, setOpenLinkPanel] = React.useState(true);

  useEffect(() => {
    if (isLinkUpdated) {
      setTimeout(() => {
        setOpenLinkPanel(false);
      }, 2000);
    }
  }, [isLinkUpdated]);

  const getText = () => {
    return (
      <Row className={styles.linkSection}>
        <Col xl={12} className={styles.linkSectionTitle}>
          <i
            className={cx(styles.backArrow, "paperflite-left-arrow")}
            onClick={onClose}
          ></i>
          <p className={cx(styles.linkTypeTitle)}>
            {link.type && textContent[link.type]?.title}
          </p>
        </Col>
        <Col xl={12}>
          <p className={cx(styles.linkTypeSubTitle)}>
            {link.type && textContent[link.type].sub_text}
          </p>
        </Col>
      </Row>
    );
  };

  const getValueForTextField = () => {
    switch (link.type) {
      case "personalised":
        return link.contact.email;
      case "campaign":
        return _.get(link.utmCampaign, "name");
    }
  };
  return (
    <div className={styles.linkSettings}>
      <Row>
        {getText()}
        <Col xl={12}>
          {link.type !== "anonymous" && (
            <Form.Control
              readOnly
              aria-describedby="basic-addon2"
              className={styles.linkInput}
              value={getValueForTextField()}
            />
          )}
        </Col>

        <div className={cx(styles.linkContainer)}>
          <Collapse isOpen={openLinkPanel} customStyles={{ padding: 0 }}>
            {isLinkUpdated && (
              <span className={styles.linkUpdated}>
                Your link has been updated!
              </span>
            )}
            {!isLinkUpdated && (
              <Row className={styles.generatedLinkRow}>
                <Col xl={10} xs={10} sm={10} >
                  <Text text={_.get(link, "url", "")||""} className={styles.generatedLink} lines={1} />
                </Col>
                <Col xl={2} xs={2} sm={2} className={styles.fadeInRight}>
                  <CopyLink link={link} />
                </Col>
              </Row>
            )}
          </Collapse>
        </div>
      </Row>

      <div className={styles.optionsFadeIn}>
        <Options
          link={link}
          openLinkPanel={openLinkPanel}
          setLinkUpdated={setIsLinkUpdated}
          setOpenLinkPanel={setOpenLinkPanel}
        />
      </div>
    </div>
  );
};

export default LinkSettings;
